// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__Au2Gt","author":"Table_author__3lNoI","authorImage":"Table_authorImage__3Jc1L","unreadRow":"Table_unreadRow__3CdYD"};